import { InteractionTwoTone } from '@ant-design/icons';
import { Button } from 'antd';

import { usePutRequest } from 'hooks';

import { Transaction } from 'codegen';

export const UpdateTransaction = ({
  snapId,
  status,
  canUpdate,
  transactionId,
}: {
  snapId?: number;
  status?: Transaction.status,
  canUpdate: boolean;
  transactionId?: number;
}) => {
  const [updateTransaction, { loading }] = usePutRequest({
    url: `/snaps/${snapId}/transactions/${transactionId}`,
  });

  const isBackedOut = status === Transaction.status.BACKED_OUT;

  if (!canUpdate || isBackedOut) {
    return null;
  }

  return (
    <Button
      type='text'
      icon={<InteractionTwoTone title='Update' />}
      loading={loading}
      onClick={() => updateTransaction()}
    />
  );
};
